import { configureStore } from "@reduxjs/toolkit";
import tabReducers from "../slices/TabSlices";
import ftReducers from "../slices/FamilyTreeSlices";
import cardReducers from "../slices/CardSlices";
import ftonBoardingReducer from "../slices/features/ftOnBoardingSlice";
import assetsonBoardingReducer from "../slices/features/assetsOnBoardingSlice";
import auditTrailReducers from "../slices/AuditTrailSlice";
import documentsReducers from "../slices/DocumentsSlice";
import casesReducers from "../slices/CasesSlice";
import permissionsReducers from "../slices/Permissions";
import usersSlice from "../slices/UserSlice";
import languageSlice from "../slices/LanguageChange";
import assetsDocuments from "../slices/yourAssets/AssetsDocumentsSlice";
import translationReducers from "../slices/TranslationSlice";
const store = configureStore({
  reducer: {
    currentLanguage: languageSlice,
    currentCard: cardReducers,
    currentTab: tabReducers,
    familyTree: ftReducers,
    ftOnBoarding: ftonBoardingReducer,
    assetsOnBoarding: assetsonBoardingReducer,
    auditTrail: auditTrailReducers,
    statusQuoDocuments: documentsReducers,
    casesState: casesReducers,
    permissions: permissionsReducers,
    user: usersSlice,
    assetsDocuments: assetsDocuments,
    translation: translationReducers,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
